/* eslint-disable */
import { sendContact } from './send-contact';
const contactDBtn = document.getElementById('contact_send_d');
const contactMBtn = document.getElementById('contact_send_m');



if (contactDBtn)
  contactDBtn.addEventListener('click', e => {
    var elements = document.getElementById("contact").elements;
    const token = document.querySelector('#contact [name="cf-turnstile-response"]')?.value;
    var obj ={};
    for(var i = 0 ; i < elements.length ; i++){
        var item = elements.item(i);
        if(item.type== 'radio'){
        if(item.checked){
            obj[item.name] = item.value;
        }
        }else{
            obj[item.name] = item.value;
        }
    }
    sendContact(obj, false, token);
});
if (contactMBtn)
contactMBtn.addEventListener('click', e => {
    var elements = document.getElementById("contact_m").elements;
    const token = document.querySelector('#contact_m [name="cf-turnstile-response"]')?.value;
    var obj ={};
    for(var i = 0 ; i < elements.length ; i++){
        var item = elements.item(i);
        if(item.type== 'radio'){
        if(item.checked){
            obj[item.name] = item.value;
        }
        }else{
            obj[item.name] = item.value;
        }
    }
    sendContact(obj, true, token);
});